import { useEffect, useRef, useContext } from 'react';

import classes from './Marketing.module.scss'
import man from '../../../../../assets/img/man.png';
import arrow from '../../../../../assets/icons/arrow-left-blue.svg';
import timer from '../../../../../assets/icons/Timer_arrow.png';
import security from '../../../../../assets/icons/security_lock.svg';
import lock from '../../../../../assets/icons/lock_v.png';
import OnlineServicesLarge from '../../../../General/Static/OnlineServices/OnlineServicesLarge';
import LoginContext from '../../../../..//store/login-context';

declare function Translate(key: string): string;

const Marketing = (props) => {   
    const advantagesRef:any = useRef(undefined);
    const sitesRef:any = useRef(undefined);
    const howRef:any = useRef(undefined);

    const ctx = useContext(LoginContext);
    
    useEffect(() => {
        if(ctx.isMarketfocus){
            advantagesRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
            ctx.toggleMarketFocus();
        }        
    },[ctx]);

    const handleAdvantagesClick = () => {        
        advantagesRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const handleAdvantagesPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            handleAdvantagesClick();  
        }
    }

    const handleSitesClick = () => {        
        sitesRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const handleSitesPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            handleSitesClick();  
        }
    }
    
    const handleHowClick = () => {        
        howRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const handleHowPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            handleHowClick();  
        }
    }

    const scrollToTop = () => {
        document.body.scrollTop = 0; //safari
        document.documentElement.scrollTop = 0;
    };

    return(
        <div className={classes.marketing_container}>
                {/* header */}
                <div className={classes.marketing_header}>
                    <div>
                        <div className={classes.marketing_header_title}>
                            {Translate("N_General_One_Account")}
                        </div>
                        <div className={classes.marketing_header_buttons_container}>
                            <button id='btn_advantages' className={classes.marketing_header_button} onClick={handleAdvantagesClick} onKeyPress={handleAdvantagesPress}>
                                <img src={arrow} alt="arrow" />
                                <span className={classes.marketing_header_button_text}>{Translate("N_General_Advantages")}</span>
                            </button>
                            <button id='btn_sites' className={classes.marketing_header_button} onClick={handleSitesClick} onKeyPress={handleSitesPress}>
                                <img src={arrow} alt="arrow" />
                                <span className={classes.marketing_header_button_text}>{Translate("N_General_Sites")}</span>
                            </button>
                            <button id='btn_how' className={classes.marketing_header_button}  onClick={handleHowClick} onKeyPress={handleHowPress}>
                                <img src={arrow} alt="arrow" />
                                <span className={classes.marketing_header_button_text}>{Translate('N_General_SignUp_lobby_info_24')}</span>
                            </button>
                        </div>
                    </div>
                    <div className={classes.imgWrapper}>
                        <img src={man} alt="man" />
                    </div>
                </div>

                {/* advantages */}
                <div className={classes.advantages_container} ref={advantagesRef}>
                    <div className={classes.title_desc}>
                        {Translate("N_General_Advantages_2")}
                    </div>
                    <div className={classes.title}>
                       {Translate("N_General_SignUp_lobby_info_25")}
                    </div>
                    <div className={classes.obj_container}>
                        <div className={classes.advantages_obj}>
                            <div className={classes.img_container}>
                                <img src={lock} alt="lock" />
                            </div>
                            <div className={classes.obj_title}>
                                {Translate("N_General_Signup_Market_10")}
                            </div>
                            <div className={classes.obj_desc}>                                
                                <div>{Translate("N_General_Signup_Market_11")}</div>
                                <div>
                                    <a 
                                        className={classes.sites_link}
                                        tabIndex={0}
                                        onClick={handleSitesClick}
                                        onKeyPress={handleSitesPress}
                                    >{Translate("N_General_Signup_Market_12")}</a>
                                </div>
                            </div>
                        </div>
                        <div className={classes.advantages_obj}>
                            <div className={classes.img_container}>
                                <img src={timer} alt="timer" />
                            </div>
                            <div className={classes.obj_title}>
                                {Translate('N_General_Signup_Market_13')}
                            </div>
                            <div className={classes.obj_desc}>
                                {Translate("N_General_SignUp_lobby_info_30")}
                            </div>
                        </div>
                        <div className={classes.advantages_obj}>
                            <div className={classes.img_container}>
                                <img src={security} alt="security" />
                            </div>
                            <div className={classes.obj_title}>
                                {Translate("N_General_Signup_Market_14")}
                            </div>
                            <div className={classes.obj_desc}>
                                {Translate("N_General_Signup_Market_15")}
                            </div>
                        </div>
                    </div>
                </div>

                {/* sites */}
                <div className={classes.sites_container} ref={sitesRef}>
                    <div className={`${classes.title_desc} ${classes.sites_title_desc}`}>
                        {Translate("N_General_Sites")}
                    </div>
                    <div className={classes.sites_title}>
                        {Translate("N_General_SignUp_lobby_info_33")}
                    </div>
                    <div className={classes.onlineServices}>
                        <OnlineServicesLarge />
                    </div>
                    <div className={classes.reg_btn_wrapper}>
                        <button id='market_reg_btn' className={classes.reg_btn} onClick={scrollToTop}>
                            {Translate("N_Login_Signup")}
                        </button>
                    </div>
                </div>

                {/* example - video */}
                <div className={classes.example_container} ref={howRef}>
                     <div className={classes.title_desc}>
                       {Translate("N_General_SignUp_lobby_info_24")}
                    </div>
                    <div className={classes.example_wrapper}>
                        <div className={classes.example_text}>                           
                            <div className={classes.example_title}>
                                {Translate("N_General_Signup_Market_16")}
                            </div>
                            <div className={classes.example_desc}>
                                {Translate("N_General_Signup_Market_17")}
                            </div>
                            <div className={classes.example_title}>
                                {Translate("N_General_Signup_Market_18")}
                            </div>
                            <div className={classes.example_desc}>
                                {Translate("N_General_Signup_Market_19")}
                            </div>
                        </div>
                        {/* <div className={classes.example_video}>                       
                            <div>                           
                                <iframe
                                    title="YouTube video player"  
                                    className={classes.video_player}  
                                    src="https://www.youtube.com/embed/-q0d6m2j2kc?si=nVJqAZ3YUupqbMga"                                
                                    frameBorder='0'
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                    referrerPolicy="strict-origin-when-cross-origin" 
                                    allowFullScreen>                                
                                </iframe>                            
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
    );
};
export default Marketing;